import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
  imageDesktop,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: false,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        overflow: hidden;
        padding-top: 15px;
      `,
      tabletWrapperStyles: css`
        padding-top: 40px;
      `,
      desktopWrapperStyles: css`
        padding-top: 0px;
      `,
    },
    containerProps: {
      tabletContainerStyles: null,
      desktopContainerStyles: css`
        flex-direction: row-reverse;
        justify-content: flex-start;
        margin: 0 auto;
        padding-left: 0;
        padding-right: 0;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      mobileContainerStyles: css`
        align-items: center;
         & > p {
          max-width: 300px;
        }
      `,
      tabletContainerStyles: css`
        h1 {
          margin-left: auto;
          margin-right: auto;
          max-width: 500px;
        }
        & > p {
          max-width: 500px;
        }
      `,
      desktopContainerStyles: css`
        margin-right: 5%;
        h1 {
          line-height: 1;
          margin-left: 0;
          margin-right: 0;
          max-width: initial;
        }
        & > div {
          max-width: initial;
        }
        margin-top: -60px;
        min-width: initial;
        width: 32%;
      `,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      imageDesktop: imageDesktop,
      mobileImageWrapperStyles: css`
        margin-bottom: -90px;
        margin-top: 30px;
        width: 134%;
        video {
          width: 100%;
        }
      `,
      tabletImageWrapperStyles: css`
        margin-bottom: -70px;
        margin-left: 0;
        margin-top: 50px;
        width: 92%;
      `,
      desktopImageWrapperStyles: css`
        margin-bottom: 0;
        margin-top: 100px;
        max-width: 63%;
        video {
          margin-left: -38px;
          width: 100%;
        }
      `,
      mobileImageStyles: css`
        margin-left: -24%;
        width: 100%;
      `,
      tabletImageStyles: css`
        margin-left: 0;
        width: auto;
       
      `,
    },
  }
}
